import { createSlice } from '@reduxjs/toolkit'

const initialState = null;

export const userSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    setUserInfo: (state,action) => {
      return action.payload;
    }
  },
})

export const { setUserInfo } = userSlice.actions

export default userSlice.reducer